import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-feature-tiles-grid',
  templateUrl: './feature-tiles-grid.component.html',
  styleUrls: ['./feature-tiles-grid.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FeatureTilesGridComponent {}
